<template>
<!-- Modal -->
<div id="PrivacyPolicy" class="modal fade" role="dialog">
  <div class="modal-dialog">

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="modal-title">Privacy policy</h4>
      </div>
      <div class="modal-body">
            <p>
                Sed dictum auctor venenatis. Nunc nec dapibus ex. Sed scelerisque eget elit rhoncus euismod. In pellentesque, sem a vehicula tincidunt, risus tortor semper odio, ac porta ipsum nulla eget dui. Sed pellentesque porta consectetur. Nulla tempus mauris augue, et vehicula nisl auctor quis. Duis eleifend quam dolor, eu semper arcu ullamcorper eu.

                Sed nibh ante, vestibulum ut nisi ut, lacinia consectetur odio. Duis interdum, leo a tincidunt molestie, lorem quam condimentum tellus, in consectetur leo orci sit amet leo. Morbi id dui eros. In eu turpis ante. Fusce dictum leo vel velit commodo, a mollis arcu pellentesque. Mauris faucibus euismod quam, vel vulputate massa gravida vitae. Morbi pharetra ultrices ornare. Interdum et malesuada fames ac ante ipsum primis in faucibus. Sed faucibus varius neque vitae bibendum. Quisque nunc est, viverra sit amet justo id, convallis fringilla nulla. Praesent orci purus, malesuada sit amet suscipit eget, tincidunt id justo.

                Aliquam scelerisque, ligula sed facilisis bibendum, augue ex finibus elit, facilisis facilisis diam dui porta mauris. Aenean nec risus in dolor lobortis finibus ut nec enim. Proin at lorem eleifend, dictum orci in, condimentum erat. Vivamus finibus justo a massa dignissim placerat. Donec placerat sit amet erat nec euismod. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Aliquam et diam tincidunt urna rhoncus molestie. Nam suscipit nisl ex, efficitur accumsan dolor blandit a. Duis rutrum iaculis neque, sed commodo lectus fermentum quis. Mauris hendrerit, magna in imperdiet tempus, dolor augue dapibus tellus, sed ultrices tortor purus vel tortor. Curabitur sodales venenatis imperdiet. Donec posuere feugiat ipsum sit amet tincidunt. Nullam ultrices blandit odio pharetra feugiat. Pellentesque nisi neque, volutpat a ultrices et, eleifend in augue. Nam ex augue, eleifend eget pharetra id, elementum in risus. Donec facilisis quis augue non aliquam.

                Morbi enim velit, pharetra sit amet tellus at, dignissim condimentum eros. Curabitur vitae aliquet leo, ac consectetur quam. In eu aliquet massa. Donec nec aliquet mauris. Phasellus dignissim dignissim est. Aenean ultricies mattis nisl non hendrerit. Curabitur molestie nulla sit amet lacus iaculis, in posuere nisi venenatis. Sed placerat lectus venenatis lacus elementum, id euismod quam vestibulum.

                Generated 5 paragraphs, 510 words, 3444 bytes of Lorem Ipsum
            </p>
      </div>
    </div>

  </div>
</div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'PrivacyPolicy',
    data() {
        return {
            msg: 'Welcome to Your Vue.js App'
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/popup/PrivacyPolicy.vue